export const letterSpacing = {
    '0.5': '0.5px',
    '1': '1px',
    '2': '2px',
    '3': '3px'
};
